import { Spacing } from '@persona-id/design-tokens';
import { memo } from 'react';
import { Field } from 'redux-form';
import styled from 'styled-components';

import { InputLabel } from 'dashboard/apps/InquiryTemplateEditor/FieldPanel/FieldPanel';
import { FieldWrapper } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateEditor/shared';
import InputField from 'dashboard/components/FormControls/InputField';
import ToggleSliderField from 'dashboard/components/FormControls/ToggleSliderField';
import HelpIcon from 'dashboard/components-lib/HelpIcon';
import { Paragraph } from 'design-system/components/Text';

const ComponentFieldWrapper = styled(FieldWrapper)`
  margin-bottom: ${Spacing[3]};
`;

const MaskComponentFieldWrapper = styled(FieldWrapper)`
  margin-top: ${Spacing[4]};
  margin-bottom: ${Spacing[3]};
`;

const StyledToggleSliderField = styled(ToggleSliderField)`
  margin-bottom: 0px;
`;

const ToggleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const BulletList = styled.ul`
  list-style: none;
  padding: ${Spacing[1]} ${Spacing[1]} 0 ${Spacing[3]};
`;

const BulletText = styled(Paragraph).attrs({ size: 'xs' })`
  margin-bottom: ${Spacing[1]};
`;

type InputMaskedTextFieldConfigComponentEditor = {
  basePath: string;
  disabled: boolean;
};

const InputMaskedTextFieldConfigComponentEditor = ({
  basePath,
  disabled,
}: InputMaskedTextFieldConfigComponentEditor) => {
  return (
    <>
      <ComponentFieldWrapper>
        <Field
          size='sm'
          type='text'
          component={InputField}
          name={`${basePath}.config.mask`}
          label={
            <>
              <InputLabel>Format</InputLabel>
              <HelpIcon>
                Determines the text format for entered text:
                <BulletList>
                  <li>
                    <BulletText># - any number</BulletText>
                  </li>
                  <li>
                    <BulletText>@ - any letter</BulletText>
                  </li>
                  <li>
                    <BulletText>* - any number or letter</BulletText>
                  </li>
                  <li>
                    <BulletText>{`any literal character (e.g. format of qwe = the first three characters must be "qwe")`}</BulletText>
                  </li>
                </BulletList>
              </HelpIcon>
            </>
          }
          disabled={disabled}
        />
      </ComponentFieldWrapper>
      <MaskComponentFieldWrapper>
        <ToggleContainer>
          <div>
            <InputLabel>Apply mask</InputLabel>
            <HelpIcon>
              Controls whether a mask is applied to entered text. When enabled, previously submitted
              values will not be used to prefill this input.
            </HelpIcon>
          </div>
          <Field
            size='sm'
            component={StyledToggleSliderField}
            name={`${basePath}.config.secure`}
            disabled={disabled}
          />
        </ToggleContainer>
      </MaskComponentFieldWrapper>

      <MaskComponentFieldWrapper>
        <ToggleContainer>
          <div>
            <InputLabel>Allow prefill when masked</InputLabel>
            <HelpIcon>
              Allows previously submitted values to be used to prefill this input, even when masking
              is applied.
            </HelpIcon>
          </div>
          <Field
            size='sm'
            component={StyledToggleSliderField}
            name={`${basePath}.config.allow-prefill-when-secure`}
            disabled={disabled}
          />
        </ToggleContainer>
      </MaskComponentFieldWrapper>
    </>
  );
};

export default memo(InputMaskedTextFieldConfigComponentEditor);
